import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";

const SystemLogService = {
    list: async (
        page = 0,
        pageSize = 10,
        sort = "createdAt:desc",
        level = null,
        source = null,
        excludeScheduler = null,
        bedrockIdeaId = null,
        email = null,
        message = null,
    ) => {
        try {
            const params = { page, pageSize, sort };
            if (level) params.level = level;
            if (source) params.source = source;
            if (excludeScheduler !== null && excludeScheduler !== undefined) params.excludeScheduler = excludeScheduler;
            if (bedrockIdeaId) params.bedrock_idea_id = bedrockIdeaId;
            if (email) params.email = email;
            const msg = String(message || "").trim();
            if (msg) params.message = encodeURIComponent(msg);
            const response = await ApiService.getData("/v1/system-log", params);
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error fetching system logs:", error);
            return {
                success: false,
                error: error.message || "Failed to fetch system logs"
            };
        }
    },

    /** GET /v1/system-log/distinct-source — distinct trimmed source strings, sorted ascending. */
    listDistinctSources: async () => {
        try {
            const response = await ApiService.getData("/v1/system-log/distinct-source");
            const list = Array.isArray(response) ? response : [];
            return { success: true, data: list.filter((s) => s != null && String(s).trim() !== "") };
        } catch (error) {
            Logger.error("Error fetching distinct log sources:", error);
            return {
                success: false,
                error: error.message || "Failed to fetch log sources",
                data: [],
            };
        }
    },

    /**
     * DELETE /v1/system-log — body `{ ids: string[] }` (nulls dropped, de-duplicated server-side).
     */
    deleteByIds: async (ids) => {
        try {
            const unique = [];
            const seen = new Set();
            for (const id of ids || []) {
                if (id == null) continue;
                const s = String(id).trim();
                if (!s || seen.has(s)) continue;
                seen.add(s);
                unique.push(s);
            }
            if (unique.length === 0) {
                return { success: false, error: "No log ids selected" };
            }
            const response = await ApiService.deleteData("/v1/system-log", { ids: unique });
            if (response?.code === "FAILURE") {
                return { success: false, error: response.message || "Failed to delete logs" };
            }
            return { success: true, data: response };
        } catch (error) {
            Logger.error("Error deleting system logs:", error);
            return {
                success: false,
                error: error.message || "Failed to delete logs",
            };
        }
    },

    findById: async (id) => {
        try {
            const response = await ApiService.getData(`/v1/system-log/${id}`);
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error fetching system log:", error);
            return {
                success: false,
                error: error.message || "Failed to fetch system log"
            };
        }
    }
};

export default SystemLogService;
